export default function ContattiDiretti() {
  const contacts = [
    {
      icon: 'ri-mail-line',
      title: 'Email',
      value: 'info@brandcapital.it',
      link: 'mailto:info@brandcapital.it',
      description: 'Scrivici per qualsiasi domanda o richiesta'
    },
    {
      icon: 'ri-phone-line',
      title: 'Telefono',
      value: '327 690 8748',
      link: 'tel:+393276908748',
      description: 'Chiamaci dal lunedì al venerdì, 9:00-18:00'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Sede',
      value: 'Modena, Italia',
      link: '#',
      description: 'Via Galileo Galilei n. 133, 41126 Modena'
    },
    {
      icon: 'ri-linkedin-box-line',
      title: 'LinkedIn',
      value: 'Brand Capital',
      link: 'https://www.linkedin.com/company/brandcapitalitalia/',
      description: 'Seguici per insights e aggiornamenti'
    }
  ];

  return (
    <section id="contatti-form" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Contatti Diretti
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Scegli il canale che preferisci. Siamo qui per rispondere a ogni tua domanda.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {contacts.map((contact, index) => (
            <a
              key={index}
              href={contact.link}
              target={contact.link.startsWith('http') ? '_blank' : undefined}
              rel={contact.link.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="bg-gradient-to-br from-purple-50 to-slate-50 p-6 rounded-xl hover:shadow-lg transition-all cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#E879F9] rounded-lg mb-4 group-hover:bg-[#D946EF] transition-all">
                <i className={`${contact.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {contact.title}
              </h3>
              <p className="text-[#22C55E] font-semibold mb-2">
                {contact.value}
              </p>
              <p className="text-gray-600 text-sm">
                {contact.description}
              </p>
            </a>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#0B1F3B] to-blue-900 rounded-2xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Preferisci compilare un form?
          </h3>
          <p className="text-blue-100 text-lg mb-8 max-w-2xl mx-auto">
            Lasciaci i tuoi dati e ti ricontatteremo entro 24 ore per fissare la tua pre-analisi gratuita.
          </p>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 max-w-2xl mx-auto">
            <p className="text-white text-lg mb-4">
              <i className="ri-information-line mr-2"></i>
              Form di contatto in arrivo
            </p>
            <p className="text-blue-100">
              Nel frattempo, puoi contattarci direttamente via email o telefono usando i riferimenti qui sopra.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
